import { render, staticRenderFns } from "./TextFormattingButtons.vue?vue&type=template&id=254b3d13&scoped=true&"
import script from "./TextFormattingButtons.vue?vue&type=script&lang=js&"
export * from "./TextFormattingButtons.vue?vue&type=script&lang=js&"
import style0 from "./TextFormattingButtons.vue?vue&type=style&index=0&id=254b3d13&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254b3d13",
  null
  
)

export default component.exports